import {
  playCoinFlip,
  playDice,
  playRollDice,
  playScratch,
  playSpin,
  playDrop,
  startMines,
  revealMines,
  cashoutMines,
  playSlots,
  buySlotsBonus,
  startBunnyCrash,
  stepBunnyCrash,
  cashoutBunnyCrash,
} from "./asyncThunk";

export const playCoinFlipBuilder = (builder) => {
  builder.addCase(playCoinFlip.pending, (state) => {
    state.coinflipPending = true;
  });
  builder.addCase(playCoinFlip.fulfilled, (state) => {
    state.coinflipPending = false;
  });
  builder.addCase(playCoinFlip.rejected, (state) => {
    state.coinflipPending = false;
  });
};

export const playDiceBuilder = (builder) => {
  builder.addCase(playDice.pending, (state) => {
    state.dicePending = true;
  });
  builder.addCase(playDice.fulfilled, (state) => {
    state.dicePending = false;
  });
  builder.addCase(playDice.rejected, (state) => {
    state.dicePending = false;
  });
};

export const playRollDiceBuilder = (builder) => {
  builder.addCase(playRollDice.pending, (state) => {
    state.rollDicePending = true;
  });
  builder.addCase(playRollDice.fulfilled, (state) => {
    state.rollDicePending = false;
  });
  builder.addCase(playRollDice.rejected, (state) => {
    state.rollDicePending = false;
  });
};

export const playScratchBuilder = (builder) => {
  builder.addCase(playScratch.pending, (state) => {
    state.scratchPending = true;
  });
  builder.addCase(playScratch.fulfilled, (state) => {
    state.scratchPending = false;
  });
  builder.addCase(playScratch.rejected, (state) => {
    state.scratchPending = false;
  });
};

export const playSpinBuilder = (builder) => {
  builder.addCase(playSpin.pending, (state) => {
    state.spinPending = true;
  });
  builder.addCase(playSpin.fulfilled, (state) => {
    state.spinPending = false;
  });
  builder.addCase(playSpin.rejected, (state) => {
    state.spinPending = false;
  });
};

export const playDropBuilder = (builder) => {
  builder.addCase(playDrop.pending, (state) => {
    state.dropPending = true;
  });
  builder.addCase(playDrop.fulfilled, (state) => {
    state.dropPending = false;
  });
  builder.addCase(playDrop.rejected, (state) => {
    state.dropPending = false;
  });
};

// minesPending covers any in-flight start/reveal/cashout request so the
// board can lock during a server round-trip.
export const minesBuilder = (builder) => {
  [startMines, revealMines, cashoutMines].forEach((thunk) => {
    builder.addCase(thunk.pending, (state) => {
      state.minesPending = true;
    });
    builder.addCase(thunk.fulfilled, (state) => {
      state.minesPending = false;
    });
    builder.addCase(thunk.rejected, (state) => {
      state.minesPending = false;
    });
  });
};

// slotsPending covers play + buy-bonus (the spin kickoff). The gamble has
// its own gamblePending flag managed locally by the page (gambling state).
export const slotsBuilder = (builder) => {
  [playSlots, buySlotsBonus].forEach((thunk) => {
    builder.addCase(thunk.pending, (state) => {
      state.slotsPending = true;
    });
    builder.addCase(thunk.fulfilled, (state) => {
      state.slotsPending = false;
    });
    builder.addCase(thunk.rejected, (state) => {
      state.slotsPending = false;
    });
  });
};

// bunnyCrashPending covers any in-flight start/step/cashout request so the
// road locks during a server round-trip.
export const bunnyCrashBuilder = (builder) => {
  [startBunnyCrash, stepBunnyCrash, cashoutBunnyCrash].forEach((thunk) => {
    builder.addCase(thunk.pending, (state) => {
      state.bunnyCrashPending = true;
    });
    builder.addCase(thunk.fulfilled, (state) => {
      state.bunnyCrashPending = false;
    });
    builder.addCase(thunk.rejected, (state) => {
      state.bunnyCrashPending = false;
    });
  });
};
